/* eslint-disable react/no-danger */
import React from 'react';
import { Typography } from '@alphakits/ui/dist';
import { BackButton } from 'src/back-button';

import { HtmlRenderer } from '../../components/html-renderer';
import { LINKS as L } from '../../constants';
import { PageWrapper } from '../../templates/page-wrapper';

import styles from '../index.module.css';

export const ClientsPolicyRu = ({ LINKS }: {LINKS: ReturnType<typeof L>}) => (
    <PageWrapper>
        <div className={ styles.title_block }>
            <Typography.Title className={ styles.title } view="small" weight="bold" tag="h3">Политика конфиденциальности для посетителей сайта</Typography.Title>
            <Typography.Text weight="medium" view="primary-small" color="secondary" className={ styles.date }>Редакция от: 15.04.21, 14:20</Typography.Text>
        </div>
        <HtmlRenderer text={ `
            <p><span style="font-weight: 400;">Настоящая Политика обработки персональных данных (далее &ndash; Политика) определяет общие принципы и порядок обработки персональных данных и меры по обеспечению их безопасности в ООО "АЛЬФА КЛИЕНТС" (далее &ndash; Оператор).</span></p>

        ` }
        />

        { console.log(LINKS) }

        <BackButton />

    </PageWrapper>
);
